import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Stepper, Step } from "react-form-stepper";
import { toast } from "react-toastify";
import { formFields } from "../constants/formFields";
import Header from "../components/Header";
import PersonalDetails from "../components/PersonalDetails";
import EshramSuccessPage from "../components/EshramSuccess";
import Loader from "../components/Loader";
import step_active from "../assets/icons/step_active.png";
import step_completed from "../assets/icons/step_completed.png";
import step_inactive from "../assets/icons/step_inactive.png";
import {
  loanFormCheckStatusApiCallHandler,
  sendLoanRequest,
  sendEshramRequest
} from "../service/loanService";
import "../style.css";
import { useEffect } from "react";
import DocUpload from '../components/DocUpload';

export default function EshramPage() {
  const [isLoading, setLoader] = useState(false);
  const [isMounted, setMounted] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [loanData, setLoanData] = useState(null);
  const [eshramFormData, setEshramFormData] = useState(null);
  const [applicationId, setApplicationId] = useState("");
  const [verifyPhoneData, setVerifyPhoneData] = useState(null);
  const search = useLocation().search;
  const company = new URLSearchParams(search).get("partner") || "";
  const emp_id = new URLSearchParams(search).get("emp_id") || "";
  let fieldsState = {};
  if (formFields && company) {
    formFields[company]?.forEach((field) => (fieldsState[field.name] = ""));
  }

  useEffect(() => {
    const _data = JSON.parse(localStorage.getItem(`${company}-${emp_id}`));
    if (_data?.loanData) {
      setLoanData(_data?.loanData);
    }

    setMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      localStorage.setItem(
        `${company}-${emp_id}`,
        JSON.stringify({ loanData: loanData })
      );
    }
  }, [activeStep, loanData, company, emp_id]);

  const redirectToDocUploadPage = (_personalDetails) => {
    setEshramFormData({
      ...eshramFormData,
      ..._personalDetails,
    });
    console.log("afafa", _personalDetails)
    setActiveStep(1);
  };

  const saveEshramForm = async (_docData) => {
    try {
      setLoader(true)
      setEshramFormData({
        ...eshramFormData,
        ..._docData
      })
      let data = {
        ...eshramFormData,
        ..._docData
      }
      const result = await sendEshramRequest(data);
      console.log("result", result)
      const { status } = result;
      if (status === "success") {
        setActiveStep(2);
        localStorage.removeItem(`${company}-${emp_id}`);
      } else {
        window.gtag("event", "submission_error", { employee_id: emp_id });
      }
    } catch (error) {
      const errorMessage = error?.message || error?.data?.message || error?.data || error || "Unknown Error";
      console.error(errorMessage);
      toast.error(`Error Occurred. Please try again later. Details: ${errorMessage}`);
    }
    finally {
      setLoader(false)
    }
  }

  const renderLoadForm = () => {
    switch (activeStep) {
      case 0:
        return (
          <PersonalDetails
            company={"eshram"}
            formFields={formFields}
            // loanData={loanData}
            redirectToStep={redirectToDocUploadPage}
          />
        );
      case 1:
        return (
          <DocUpload
            redirectToStep={saveEshramForm}
          />
        );
      case 2:
        return (
          <EshramSuccessPage />
        );
      default:
        break;
    }
  };
  const getStepImg = (_fromStep) => {
    if (activeStep === _fromStep) {
      return step_active;
    } else if (activeStep > _fromStep) {
      return step_completed;
    } else if (activeStep < _fromStep) {
      return step_inactive;
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <Header hidePartnerLogo={true} />
      <>
        <Stepper activeStep={activeStep} className="!p-0 loan-stepper my-3">
          <Step
            label="Step 1"
            className="custom-step"
            style={{
              backgroundImage: `URL(${getStepImg(0)})`,
              backgroundSize: "cover",
              backgroundColor: "unset",
            }}
          />
          <Step
            label="Step 2"
            className="custom-step"
            style={{
              backgroundImage: `URL(${getStepImg(1)})`,
              backgroundSize: "cover",
              backgroundColor: "unset",
            }}
          />
          <Step
            label="Step 3"
            className="custom-step"
            style={{
              backgroundImage: `URL(${getStepImg(2)})`,
              backgroundSize: "cover",
              backgroundColor: "unset",
            }}
          />
        </Stepper>
        {renderLoadForm()}
      </>
    </>
  );
}
